import produce, { Draft } from "immer"

import { AccommodationService } from "../common/types/accommodation"

type State = {
  accommodationServicesList: AccommodationService[],
  accommodationServices: {
    [accommodationServiceId: string]: AccommodationService
  }
}

const accommodation = {
  state: {
    accommodationServicesList: [],
    accommodationServices: {}
  } as State,
  reducers: {
    loaded: produce((draft: Draft<State>, payload: Partial<State>) => {
      Object.assign(draft, payload)
      draft.accommodationServices = payload.accommodationServicesList.reduce((acc, current) => {
        return {...acc, [current.id]: current}
      }, {})
    })
  }
}

export default accommodation